import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const AplicacionesViguetaWpc = () => {
  return (
    <section className="pb-xxl-20">
      <div className="container">
        <div className="row align-items-center">
          {/* Columna de texto */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">ideal para múltiples proyectos arquitectónicos</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
              Aplicaciones Versátiles
              </h2>
            </div>
            <div className="mb-5">
            <p className="mb-1-6 mb-sm-2-2">
            La vigueta WPC destaca por su versatilidad, siendo ideal para múltiples proyectos arquitectónicos, 
            su diseño estético la hace ideal para aplicaciones interiores como vigas expuestas en techos o elementos de acento en paredes.
            </p>
            <div className="w-xl-90 w-xxl-90 mb-6">
              <BannerNoInstalacion />
            </div>

              {/* Tarjetas */}
              <Tarjeta
                titulo="Estructuras Exteriores"
                descripcion="Utilizada como elemento estructural o decorativo en pérgolas, techos y fachadas exteriores."
                delay="200ms"
              />
              <Tarjeta
                titulo="Diseños de Jardines y Terrazas "
                descripcion="Perfecta para crear ambientes cálidos y modernos en áreas de convivencia al aire libre."
                delay="400ms"
              />
              <Tarjeta
                titulo="Espacios Comerciales"
                descripcion="Añade un toque contemporáneo y funcional a restaurantes, hoteles y locales comerciales, con acabados que destacan."
                delay="600ms"
              />
            </div>
            <a
              href="contacto-decototal"
              className="butn-style7 rounded wow fadeInUp"
              data-wow-delay="400ms"
            >
              Cotiza Ahora
            </a>
          </div>
          {/* Columna de imagen */}
          <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-lg-0">
            <div className="extra-style-01">
              <img
                className="rounded"
                src="/assets/img/productos/vigueta-wpc/vigueta-wpc-intro-a.jpg"
                alt="vigueta wpc"
              />
              <div className="image-shape1">
                <img
                  className="d-none d-md-block"
                  src="/assets/img/productos/vigueta-wpc/vigueta-wpc-intro-small.jpg"
                  alt="vigueta wpc"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Tarjeta = ({ titulo, descripcion, delay }) => {
  return (
    <div className={`card card-style21 border-0 wow fadeInUp`} data-wow-delay={delay}>
      <div className="d-flex">
        <span className="card-icon">
          <i className="fa-solid fa-check"></i>
        </span>
        <div className="card-content">
          <h5 className="card-title">{titulo}</h5>
          <p className="card-disc w-lg-85 w-xl-100">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default AplicacionesViguetaWpc;